"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormControl = _interopRequireDefault(require("@material-ui/core/FormControl"));

var _InputLabel = _interopRequireDefault(require("@material-ui/core/InputLabel"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _OutlinedInput = _interopRequireDefault(require("@material-ui/core/OutlinedInput"));

var _FormHelperText = _interopRequireDefault(require("@material-ui/core/FormHelperText"));

var _jsxRuntime = require("react/jsx-runtime");

function TextSelectMultiple(props) {
  var inputLabel = _react.default.useRef(null);

  var _React$useState = _react.default.useState(0),
      _React$useState2 = (0, _slicedToArray2.default)(_React$useState, 2),
      labelWidth = _React$useState2[0],
      setLabelWidth = _React$useState2[1];

  _react.default.useEffect(function () {
    setLabelWidth(inputLabel.current.offsetWidth);
  }, []);

  var inputId = "TextSelectMultiple".concat(props.id);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FormControl.default, {
    variant: "outlined",
    disabled: props.disabled,
    error: props.error,
    className: "custom-text-field",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InputLabel.default, {
      ref: inputLabel,
      htmlFor: inputId,
      children: props.label
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Select.default, {
      value: props.value,
      onChange: props.onChange,
      input: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OutlinedInput.default, {
        labelWidth: labelWidth,
        id: inputId
      }),
      multiple: true,
      renderValue: props.renderValue,
      children: props.children
    }), props.helperText && /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormHelperText.default, {
      children: props.helperText
    })]
  });
}

TextSelectMultiple.defaultProps = {
  disabled: false,
  renderValue: function renderValue(selected) {
    return selected.join(', ');
  }
};
TextSelectMultiple.propTypes = {
  value: _propTypes.default.array.isRequired,
  id: _propTypes.default.string.isRequired,
  renderValue: _propTypes.default.func,
  error: _propTypes.default.bool,
  onChange: _propTypes.default.func,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  disabled: _propTypes.default.bool,
  helperText: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]),
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]).isRequired
};
var _default = TextSelectMultiple;
exports.default = _default;
//# sourceMappingURL=TextSelectMultiple.js.map